import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {new Date().getFullYear()} Zimetafsiriwa. All rights reserved.</p>
        <p>Watch the best movies and series, pay once, watch forever.</p>
      </div>
    </footer>
  );
}
